"use client"

import { useEffect } from "react"
import { pageErrorToast } from "../error"
import DashboardBreadcrumsLoading from "./loading"

export default function Error({ error }: { error: any }) {
  useEffect(() => pageErrorToast(error), [error])
  return <DashboardBreadcrumsLoading />
}